import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useStore, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
    APIS,
    SF_IRM_PROFILE_SRCH,
    SG_IRM_PROFILE_CO_LIST,
    SG_IRM_PROFILE_CSBR_CO_LIST,
    SG_IRM_PROFILE_CSBR_LIST,
    SG_IRM_PROFILE_HSCD_LIST,
    SG_IRM_PROFILE_PSN_LIST,
} from "./services/ComnCdService";
/**
 * 위험관리 프로파일 목록 - 업체/관세사/품목
 * @param props
 * @returns
 */
export const IrmProfileLst = (props: any) => {
    const pgeUid = "irmProfileLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        profileSch: useForm({
            defaultSchema: SF_IRM_PROFILE_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        profileLst: useGrid({
            defaultSchema:
                (params.profile === "co" && params.prflDvnCd === "psn") ? SG_IRM_PROFILE_PSN_LIST
                    : (params.profile === "co" && params.prflDvnCd !== "psn") ? SG_IRM_PROFILE_CO_LIST
                      : (params.profile === "csbr" && params.prflDvnCd === "02") ? SG_IRM_PROFILE_CSBR_LIST
                        : (params.profile === "csbr" && params.prflDvnCd !== "02") ? SG_IRM_PROFILE_CSBR_CO_LIST
                        : params.profile === "hscd" ? SG_IRM_PROFILE_HSCD_LIST : SG_IRM_PROFILE_CO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getProfileLst: useFetch({
            api: (page = grid.profileLst.page) => {
                if (params.profile === "co") {
                    return APIS.getPrflCoLst(
                        { ...form.profileSch.getValues(), profile: params.profile, prflDvnCd: params.prflDvnCd == "psn" ? "01" : params.prflDvnCd },
                        page,
                        grid.profileLst.size,
                    );
                } else if (params.profile === "csbr" && params.prflDvnCd === "02") {
                    return APIS.getPrflCsbrLst(
                        { ...form.profileSch.getValues(), profile: params.profile, prflDvnCd: params.prflDvnCd },
                        page,
                        grid.profileLst.size,
                    );
                } else if (params.profile === "csbr" && params.prflDvnCd !== "02") {
                    return APIS.getPrflCsbrCoLst(
                        { ...form.profileSch.getValues(), profile: params.profile, prflDvnCd: params.prflDvnCd },
                        page,
                        grid.profileLst.size,
                    );
                } else if (params.profile === "hscd") {
                    return APIS.getPrflHscdLst(
                        { ...form.profileSch.getValues(), profile: params.profile, prflDvnCd: params.prflDvnCd },
                        page,
                        grid.profileLst.size,
                    );
                } else {
                    return APIS.getProfileLst(
                        { ...form.profileSch.getValues(), profile: params.profile, prflDvnCd: params.prflDvnCd },
                        page,
                        grid.profileLst.size,
                    );
                }
            },
            enabled: comnUtils.isEmpty(form.profileSch.errors) && form.profileSch.isSubmitted,
            key: [grid.profileLst.page, grid.profileLst.size],
            onSuccess: (data: any) => {
                setStore(pgeUid, {
                    form: form.profileSch.getValues(),
                    page: grid.profileLst.page,
                    size: grid.profileLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.profileSch.handleSubmit(
                () => {
                    grid.profileLst.setPage(0);
                    fetch.getProfileLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.profileLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_profileLst: {
            cell: {
                idntfNo: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                if (params.multiple === true) {
                                    props?.callback?.({ data: [{ ...rowValues }] });
                                } else {
                                    props?.callback?.({ code: value, label: rowValues.coNm });
                                }
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.profileLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={"Profile"} info={false}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                {params.profile === "co" && params.prflDvnCd === "psn" && <Group.Label label={"L_TXPR_IDNTF_NO"} />}
                                {params.profile === "co" && params.prflDvnCd !== "psn" && <Group.Label label={"L_BSNS_RGSR_NO"} />}
                                {params.profile === "csbr" && params.prflDvnCd === "02" && <Group.Label label={"L_CSBR_SGN"} />}
                                {params.profile === "csbr" && params.prflDvnCd !== "02" && <Group.Label label={"L_TXPR_IDNTF_NO"} />}
                                {params.profile === "hscd" && <Group.Label label={"L_HS_CD"} />}
                                <Group.Col>
                                    <Group.Control {...form.profileSch.schema.idntfNo} />
                                </Group.Col>
                                {params.profile === "co" && params.prflDvnCd === "psn" &&<Group.Label label={"L_NM"} />}
                                {params.profile === "co" && params.prflDvnCd !== "psn" &&<Group.Label label={"L_CO_NM"} />}
                                {params.profile === "csbr" && <Group.Label label={"L_CO_NM"} />}
                                {params.profile === "hscd" && <Group.Label label={"L_ITM_NM"} />}
                                <Group.Col>
                                    <Group.Control {...form.profileSch.schema.coNm} />
                                </Group.Col>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.profileSch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid
                        {...grid.profileLst.grid}
                        data={fetch.getProfileLst.data?.profileList}
                        render={render.grid_profileLst}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
